<template>
  <v-app>
    <v-app-bar
      :collapse-on-scroll="collapseOnScroll"
      :hide-on-scroll="hideOnScroll"
      fixed
      flat
      :color="toolbarColor"
      class="hidden-md-and-down"
    >
      <img
        v-if="showSmallLogo"
        src="images/logo-color-smaller.png"
        width="120"
        class="pt-5"
      />
      <v-spacer></v-spacer>
      <v-btn text @click="$vuetify.goTo('#prodej-piva', easingOptions)">
        <span class="white-text menu">Prodej piv</span>
      </v-btn>
      <v-btn text @click="$vuetify.goTo('#nase-piva', easingOptions)">
        <span class="white-text menu">Naše piva</span>
      </v-btn>
      <v-btn text @click="$vuetify.goTo('#historie', easingOptions)">
        <span class="white-text menu">Historie</span>
      </v-btn>
      <v-btn text @click="$vuetify.goTo('#kontakt', easingOptions)">
        <span class="white-text menu">Kontakt</span>
      </v-btn>
    </v-app-bar>
    <v-app-bar
      dark
      fixed
      class="main-background hidden-md-and-up"
      color="primary"
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      disable-resize-watcher
      dark
      class="primary"
      v-model="drawer"
      fixed
    >
      <v-toolbar dark class="primary" text>
        <v-list>
          <v-list-item>
            <v-list-item-title class="title">Menu</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-toolbar>

      <v-divider></v-divider>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-btn
              text
              @click="
                $vuetify.goTo('#prodej-piva', easingOptions);
                {
                  {
                    drawer = false;
                  }
                }
              "
              >Prodej piva</v-btn
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-btn
              text
              @click="
                $vuetify.goTo('#nase-piva', easingOptions);
                {
                  {
                    drawer = false;
                  }
                }
              "
              >Naše piva</v-btn
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-btn
              text
              @click="
                $vuetify.goTo('#historie', easingOptions);
                {
                  {
                    drawer = false;
                  }
                }
              "
              >Historie</v-btn
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-btn
              text
              @click="
                $vuetify.goTo('#kontakt', easingOptions);
                {
                  {
                    drawer = false;
                  }
                }
              "
              >Kontakt</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <!-- <v-overlay :value="overlay">
      <v-container fluid justify-end>
        <v-row no-gutters justify="end">
          <v-btn color="transparent" @click="overlay = false">
            <v-icon large>close</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="end">
          <v-col>
            <v-card class="mx-auto" max-width="400" color="transparent">
              <v-img class="white--text align-end" src="images/prodej-pet.png"></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>-->
    <v-content>
      <section class="module parallax" id="main-parallax">
        <!-- <v-dialog max-width="600" v-model="overlay">
          <v-btn color="transparent" @click="overlay = false">
            <v-icon color="white" large>close</v-icon>
          </v-btn>
          <img src="images/prodej-pet.png" />
        </v-dialog>-->
        <div class="container logo-container">
          <img src="images/logo-color-small.png" id="logo" />
        </div>
      </section>

      <section class="paper-bg" id="prodej-piva">
        <v-layout class="pt-5" align-center justify-center column>
          <v-flex>
            <h1>Prodej piva</h1>
          </v-flex>
        </v-layout>
        <v-layout class="pt-5" align-center justify-center column>
          <v-flex>
            <h3>Spodně kvašená piva</h3>
          </v-flex>
        </v-layout>
        <v-layout justify-center>
          <v-flex lg4 md6>
            <v-data-table
              id="beer-table"
              class="transparent font"
              :headers="headers"
              :items="bottomFermentedBeers"
              :items-per-page="10"
              item-key="name"
              :disable-filtering="true"
              :disable-sort="true"
              :mobile-breakpoint="1"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fast_rewind',
                lastIcon: 'fast_forward',
                prevIcon: 'keyboard_arrow_left',
                nextIcon: 'keyboard_arrow_right',
                itemsPerPageOptions: [10, 20, -1],
                itemsPerPageText: 'Počet piv na stránku',
              }"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="beer in items" :key="beer.name">
                    <td class="beer-name">{{ beer.name }}</td>
                    <td class="pl-4 beer-column">
                      <v-checkbox
                        v-show="beer.isKeg"
                        color="success"
                        :input-value="beer.isKeg"
                        readonly
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-show="beer.isKeg === false"
                        color="primary"
                        value
                        readonly
                        indeterminate
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="pl-5 beer-column">
                      <v-checkbox
                        v-show="beer.isDraught"
                        color="success"
                        :input-value="beer.isDraught"
                        readonly
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-show="beer.isDraught === false"
                        color="primary"
                        value
                        readonly
                        indeterminate
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="pl-4 beer-column">
                      <v-checkbox
                        v-show="beer.isBottled"
                        color="success"
                        :input-value="beer.isBottled"
                        readonly
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-show="beer.isBottled === false"
                        color="primary"
                        value
                        readonly
                        indeterminate
                        hide-details
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>


            <v-layout class="pt-5" align-center justify-center column>
              <v-flex>
                <h3>Svrchně kvašená piva</h3>
              </v-flex>
            </v-layout>
            <v-data-table
              id="beer-table"
              class="transparent font"
              :headers="headers"
              :items="topFermentedBeers"
              :items-per-page="10"
              item-key="name"
              :disable-filtering="true"
              :disable-sort="true"
              :mobile-breakpoint="1"
              :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fast_rewind',
                lastIcon: 'fast_forward',
                prevIcon: 'keyboard_arrow_left',
                nextIcon: 'keyboard_arrow_right',
                itemsPerPageOptions: [10, 20, -1],
                itemsPerPageText: 'Počet piv na stránku',
              }"
            >
              <template v-slot:body="{ items }">
                <tbody>
                  <tr v-for="beer in items" :key="beer.name">
                    <td class="beer-name">{{ beer.name }}</td>
                    <td class="pl-4 beer-column">
                      <v-checkbox
                        v-show="beer.isKeg"
                        color="success"
                        :input-value="beer.isKeg"
                        readonly
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-show="beer.isKeg === false"
                        color="primary"
                        value
                        readonly
                        indeterminate
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="pl-5 beer-column">
                      <v-checkbox
                        v-show="beer.isDraught"
                        color="success"
                        :input-value="beer.isDraught"
                        readonly
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-show="beer.isDraught === false"
                        color="primary"
                        value
                        readonly
                        indeterminate
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="pl-4 beer-column">
                      <v-checkbox
                        v-show="beer.isBottled"
                        color="success"
                        :input-value="beer.isBottled"
                        readonly
                        hide-details
                      ></v-checkbox>
                      <v-checkbox
                        v-show="beer.isBottled === false"
                        color="primary"
                        value
                        readonly
                        indeterminate
                        hide-details
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center>
          <div>
              <img src="images/cenik.png">
            </div>
        </v-layout>
      </section>
      <section class="module parallax" id="nabidka-piv-parallax"></section>
      <section id="nase-piva">
        <v-layout
          :class="{
            'pt-2': $vuetify.breakpoint.smAndDown,
            'pa-5': $vuetify.breakpoint.mdAndUp,
          }"
          class="paper-bg"
          align-center
          justify-center
          column
        >
          <v-flex>
            <h1>Naše piva</h1>
          </v-flex>
          <v-flex>
            <h3>Spodně kvašená piva</h3>
          </v-flex>
          <v-container grid-list-lg>
            <v-layout justify-center wrap>
              <v-flex
                v-for="(item, index) in bottomFermentedBeers"
                :key="item.name"
                md4
                xs12
                sm6
                lg2
              >
                <v-card
                  class="clickable"
                  @click.native="showBottomFermentedDialog(index)"
                >
                  <v-img :src="item.labelThumbnailPath"></v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
          <v-flex>
            <h3>Svrchně kvašená piva</h3>
          </v-flex>
          <v-container grid-list-lg>
            <v-layout justify-center wrap>
              <v-flex
                v-for="(item, index) in topFermentedBeers"
                :key="item.name"
                md4
                xs12
                sm6
                lg2
              >
                <v-card
                  class="clickable"
                  @click.native="showTopFermentedDialog(index)"
                >
                  <v-img :src="item.labelThumbnailPath"></v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
        <v-dialog v-model="topFermentedDialog">
          <v-card>
            <v-container>
              <v-row>
                <v-col>
                  <v-card-title class="justify-center">
                    <h1>{{ topFermentedBeers[topFermentedIndex].name }}</h1>
                  </v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p class="beer-description">
                    {{ topFermentedBeers[topFermentedIndex].description }}
                  </p>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="auto">
                  <v-img
                    :src="topFermentedBeers[topFermentedIndex].labelPath"
                  ></v-img>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col
                  cols="auto"
                  :class="{ hidden: $vuetify.breakpoint.mdAndDown }"
                >
                  <div class="beer-properties">
                    <p>
                      <span class="bold">Styl:</span>
                      {{ topFermentedBeers[topFermentedIndex].style }}
                    </p>
                    <p>
                      <span class="bold">Alkohol:</span>
                      {{ topFermentedBeers[topFermentedIndex].alcohol }}
                    </p>
                    <p>
                      <span class="bold">EPM:</span>
                      {{ topFermentedBeers[topFermentedIndex].epm }}
                    </p>
                    <p>
                      <span class="bold">Hořkost:</span>
                      {{ topFermentedBeers[topFermentedIndex].bitterness }}
                    </p>
                    <p>
                      <span class="bold">Chmel:</span>
                      {{ topFermentedBeers[topFermentedIndex].hops }}
                    </p>
                  </div>
                </v-col>
                <v-col
                  cols="auto"
                  :class="{ hidden: $vuetify.breakpoint.mdAndDown }"
                >
                  <div class="beer-properties">
                    <p>
                      <span class="bold">Slad:</span>
                      {{ topFermentedBeers[topFermentedIndex].malt }}
                    </p>
                    <p>
                      <span class="bold">Voda:</span>
                      {{ topFermentedBeers[topFermentedIndex].water }}
                    </p>
                    <p>
                      <span class="bold">Období produkce:</span>
                      {{
                        topFermentedBeers[topFermentedIndex].productionPeriod
                      }}
                    </p>
                    <p>
                      <span class="bold">Barva:</span>
                      <span class="nowrap">{{
                        topFermentedBeers[topFermentedIndex].color
                      }}</span>
                    </p>
                    <p>
                      <span class="bold">Balení:</span>
                      <span class="nowrap">{{
                        topFermentedBeers[topFermentedIndex].package
                      }}</span>
                    </p>
                  </div>
                </v-col>
                <v-col
                  cols="auto"
                  :class="{ hidden: $vuetify.breakpoint.lgAndUp }"
                >
                  <div class="beer-properties">
                    <p>
                      <span class="bold">Styl:</span>
                      {{ topFermentedBeers[topFermentedIndex].style }}
                    </p>
                    <p>
                      <span class="bold">Alkohol:</span>
                      {{ topFermentedBeers[topFermentedIndex].alcohol }}
                    </p>
                    <p>
                      <span class="bold">EPM:</span>
                      {{ topFermentedBeers[topFermentedIndex].epm }}
                    </p>
                    <p>
                      <span class="bold">Hořkost:</span>
                      {{ topFermentedBeers[topFermentedIndex].bitterness }}
                    </p>
                    <p>
                      <span class="bold">Chmel:</span>
                      {{ topFermentedBeers[topFermentedIndex].hops }}
                    </p>
                    <p>
                      <span class="bold">Slad:</span>
                      {{ topFermentedBeers[topFermentedIndex].malt }}
                    </p>
                    <p>
                      <span class="bold">Voda:</span>
                      {{ topFermentedBeers[topFermentedIndex].water }}
                    </p>
                    <p>
                      <span class="bold">Období produkce:</span>
                      {{
                        topFermentedBeers[topFermentedIndex].productionPeriod
                      }}
                    </p>
                    <p>
                      <span class="bold">Balení:</span>
                      <span class="nowrap">{{
                        topFermentedBeers[topFermentedIndex].package
                      }}</span>
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog v-model="bottomFermentedDialog">
          <v-card>
            <v-container>
              <v-row>
                <v-col>
                  <v-card-title class="justify-center">
                    <h1>
                      {{ bottomFermentedBeers[bottomFermentedIndex].name }}
                    </h1>
                  </v-card-title>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <p class="beer-description">
                    {{ bottomFermentedBeers[bottomFermentedIndex].description }}
                  </p>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="auto">
                  <v-img
                    :src="bottomFermentedBeers[bottomFermentedIndex].labelPath"
                  ></v-img>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col
                  cols="auto"
                  :class="{ hidden: $vuetify.breakpoint.mdAndDown }"
                >
                  <div class="beer-properties">
                    <p>
                      <span class="bold">Styl:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].style }}
                    </p>
                    <p>
                      <span class="bold">Alkohol:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].alcohol }}
                    </p>
                    <p>
                      <span class="bold">EPM:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].epm }}
                    </p>
                    <p>
                      <span class="bold">Hořkost:</span>
                      {{
                        bottomFermentedBeers[bottomFermentedIndex].bitterness
                      }}
                    </p>
                    <p>
                      <span class="bold">Chmel:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].hops }}
                    </p>
                  </div>
                </v-col>
                <v-col
                  cols="auto"
                  :class="{ hidden: $vuetify.breakpoint.mdAndDown }"
                >
                  <div class="beer-properties">
                    <p>
                      <span class="bold">Slad:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].malt }}
                    </p>
                    <p>
                      <span class="bold">Voda:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].water }}
                    </p>
                    <p>
                      <span class="bold">Období produkce:</span>
                      {{
                        bottomFermentedBeers[bottomFermentedIndex]
                          .productionPeriod
                      }}
                    </p>
                    <p>
                      <span class="bold">Barva:</span>
                      <span class="nowrap">{{
                        bottomFermentedBeers[bottomFermentedIndex].color
                      }}</span>
                    </p>
                    <p>
                      <span class="bold">Balení:</span>
                      <span class="nowrap">{{
                        bottomFermentedBeers[bottomFermentedIndex].package
                      }}</span>
                    </p>
                  </div>
                </v-col>
                <v-col
                  cols="auto"
                  :class="{ hidden: $vuetify.breakpoint.lgAndUp }"
                >
                  <div class="beer-properties">
                    <p>
                      <span class="bold">Styl:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].style }}
                    </p>
                    <p>
                      <span class="bold">Alkohol:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].alcohol }}
                    </p>
                    <p>
                      <span class="bold">EPM:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].epm }}
                    </p>
                    <p>
                      <span class="bold">Hořkost:</span>
                      {{
                        bottomFermentedBeers[bottomFermentedIndex].bitterness
                      }}
                    </p>
                    <p>
                      <span class="bold">Chmel:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].hops }}
                    </p>
                    <p>
                      <span class="bold">Slad:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].malt }}
                    </p>
                    <p>
                      <span class="bold">Voda:</span>
                      {{ bottomFermentedBeers[bottomFermentedIndex].water }}
                    </p>
                    <p>
                      <span class="bold">Období produkce:</span>
                      {{
                        bottomFermentedBeers[bottomFermentedIndex]
                          .productionPeriod
                      }}
                    </p>
                    <p>
                      <span class="bold">Balení:</span>
                      <span class="nowrap">{{
                        bottomFermentedBeers[bottomFermentedIndex].package
                      }}</span>
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-dialog>
       
      </section>
      <section class="module parallax" id="historie-parallax"></section>
      <section id="historie">
        <v-layout
          :class="{
            'pa-2': $vuetify.breakpoint.smAndDown,
            'pa-5': $vuetify.breakpoint.mdAndUp,
          }"
          class="paper-bg"
          align-center
          justify-center
          column
        >
          <v-flex>
            <h1>Historie pivovaru</h1>
          </v-flex>
          <v-flex>
            <p class="justified">
              První písemné zmínky o pivovaru v Paskově se objevily již ve 13.
              století. V Paskově již tehdy měla stát tvrz, dvůr, mlýn a palírna
              s pivovarem. Důležitým milníkem pro paskovský pivovar byl r. 1517,
              ve kterém byla mezi šlechtou a královskými městy uzavřena
              Svatováclavská smlouva, na základě které šlechta přiznala
              zástupcům měst právo třetího hlasu na zemských sněmech. Na oplátku
              města zase přiznala šlechtě právo na vaření piva a jinou
              hospodářskou činnost.
            </p>
          </v-flex>

          <v-flex v-if="toggleHist" transition="expand">
            <p class="justified">
              V Paskově byl založen pivovar jako panský již rok následující,
              tedy v r. 1518. V kronice Paskova je první zmínka o pivovaru a
              panské hospodě v Paskově z r. 1525. Název pivovaru přímo jako
              Panský pivovar Paskov (v Paskově) se však v písemnostech objevuje
              až později, a to v r. 1537, kdy paskovské panství držel Jan z
              Kadaně.
            </p>

            <p class="justified">
              V tomto období mohlo být v Paskovském panství přibližně 1000
              obyvatel, kteří prostřednictvím pivovaru notně přispívali do
              panské pokladny, jelikož měli povinnost odběru piva, např. při
              svatbách.
            </p>

            <p class="justified">
              Tehdejší pivovar zásoboval i další obce, které v té tobě byly
              součástí paskovského panství, a to Hrabovou, Hrabůvku, Novou
              Bělou, Krmelín a Žabeň. V kronice Paskova je údaj, že v r. 1525
              zde bylo 50 příbytků. Pokud v každém žilo cca 10 osob, celkový
              počet obyvatel Paskovského panství se mohl blížit číslu 500. V
              publikaci J. Stibora „Dějiny Krmelína“ se píše: „V šesti obcích
              panství (paskovského) se ročně vyšenkovalo 150 beček piva a
              předpokládaný příjem činil 1 000 rýnských zlatých. Při každém
              obnovení obecní rady museli krmelínští radní povinně pohostit obec
              dvěma vědry piva. Dokonce ke každé svatební veselce museli
              svatebčané koupit až 4 vědra piva. Bečka obsahovala cca 227 l.
              Výstav našeho paskovského pivovaru tedy byl 34 050 l piva.
              Tehdejší pivo bylo nízkoalkoholické, v dnešní době by tomu
              odpovídala sedmička.
            </p>

            <p class="justified">
              V 17. století se pak v Paskově začal pěstovat chmel. Chmelnice se
              rozprostírala kolem mlýnského náhonu v místě zvaném Štěpnice.
              Chmele bylo dostatek pro pivovar, ale i na vývoz. Později byl
              areál pivovaru několikrát přestavován a modernizován. Dne 5. dubna
              1880 byl areál pivovaru zničen rozsáhlým požárem. Téhož roku byl
              pivovar opraven a přestavěn. V roce 1894 byla k budově pivovaru
              přistavěna sladovna.
            </p>

            <p class="justified">
              Vrcholu rozvoje dosáhlo paskovské pivovarnictví koncem 19.
              století. Výstav piva dosáhl v letech 1898/99 cca 13 tisíc hl. V
              paskovském pivovaru se vařilo vynikající pivo pod značkou A la
              Pils. Tato značka se nakonec stala předmětem soudního sporu mezi
              plzeňským pivovarem a majitelem paskovského velkostatku. Soud
              skončil vítezstvím paskovského pivovaru, kterému bylo s ohledem na
              vynikající vlastnosti piva ponecháno právo značku A la Pils
              používat.
            </p>
            <p class="justified">
              Pivo v paskovském pivovaru se vařilo dále i po jeho vykoupení od
              hraběte Saint Genois, a s vařením se přestalo až krátce před první
              světovou válkou (r. 1913). Poté byla výroba piva v Paskově na více
              než 100 let ukončena. Objekt pivovaru pak dál sloužil již jen jako
              sladovna. Po válce byl v r. 1927 bývalý pivovar a palírna
              odprodány šlechtickým majitelem JUDr. Otto Stolberg - Stolbergem
              konkurenčnímu pivovaru v Moravské Ostravě, současnému Ostravaru,
              který přeměnil bývalý pivovar na sklady a sýpku. Po 2. světové
              válce bylo přistoupeno k částečné demolici budov pivovaru (r.
              1955), např. byl zbourán komín. Současně byla zahájena výstavba
              nového bytového domu o 12 bytech, který vznikl na místě bývalé
              sladovny. Zbylé budovy pivovaru byly poté buď nevyužité a chátraly
              anebo byly částečně využívané drobnými firmami, a to nadále jako
              sklady, např. ovoce a zeleniny.
            </p>

            <p class="justified">
              Na konci r. 2017 byla budova pivovaru odkoupena současným
              majitelem, který zde bez znalosti historie budovy plánoval založit
              pivovar. Shodou okolností se nedlouho poté dozvěděl, že budova v
              minulosti jako pivovar skutečně sloužila. Po více než 105 letech
              se tak v poslední z budov bývalého paskovského pivovaru opět vaří
              pivo, a to zejména v jeho přední části. Stále však probíhají práce
              na zbylých částech budovy, ve kterých by chtěl majitel časem
              vytvořit restauraci, pivní lázně a penzion. Tak Dej Bůh Štěstí!
            </p>
          </v-flex>
          <v-btn color="primary" v-on:click="toggleHistory()">
            {{ historyBtnText }}
          </v-btn>
        </v-layout>
      </section>
      <section class="module parallax" id="kontakt-parallax"></section>
      <section id="kontakt">
        <v-layout
          :class="{
            'pa-2': $vuetify.breakpoint.smAndDown,
            'pa-5': $vuetify.breakpoint.mdAndUp,
          }"
          class="primary white-text"
          column
        >
          <v-layout justify-center align-center column>
            <v-flex
              :class="{
                'pb-4': $vuetify.breakpoint.smAndUp,
              }"
            ></v-flex>
          </v-layout>
          <v-layout wrap justify-space-between>
            <v-flex xs12 md2>
              <h2>Kontakt</h2>
              <v-flex>
                Nádražní 28
                <br />Paskov, Moravskolezský Kraj, <br />Czech Republic
                <br />
                <br />Tel. pivovar:
                <br />
                <!-- <a class="link" href="tel:+420602502455">+420 602 502 455</a> -->
                <!-- <br />Tel. hospoda + zahrádka: -->
                 <!-- <br /> -->
                <a class="link" href="tel:+420602713860">+420 602 713 860</a>
                <br />
                <br /><a href="mailto:pivovarpaskov@seznam.cz"
                  >pivovarpaskov@seznam.cz</a
                >
              </v-flex>
              <v-flex
                :class="{
                  'pt-2': $vuetify.breakpoint.smAndDown,
                  'pt-4': $vuetify.breakpoint.smAndUp,
                }"
              >
                <a href="https://www.facebook.com/pivovarpaskov">
                  <img src="images/fb.png" alt="facebook" />
                </a>

                <a href="https://www.instagram.com/pivovarpaskov/">
                  <img src="images/ig.png" alt="instagram" />
                </a>
              </v-flex>
            </v-flex>
            <!-- <v-flex xs6 md4 my-sm-10 my-md-0 my-10>
              <h2>Otevírací doba</h2>
              <v-flex>
              <h3>Pivovar</h3>
                <v-simple-table dark>
                  <tbody>
                    <tr>
                      <td>Pondělí</td>
                      <td>
                        zavřeno
                      </td>
                    </tr>
                    <tr>
                      <td>Úterý - Neděle</td>
                      <td>
                        11 - 16h
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>

                <h3>Hospoda</h3>
                <v-simple-table dark>
                  <tbody>
                    <tr>
                      <td>Pondělí</td>
                      <td>
                        zavřeno
                      </td>
                    </tr>
                    <tr>
                      <td>Úterý - Neděle</td>
                      <td>
                        16 - 22h
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-flex>
            </v-flex> -->
            <v-flex
              :class="{
                'pt-4': $vuetify.breakpoint.smAndDown,
              }"
              xs12
              md6
            >
              <iframe
                id="map"
                frameborder="0"
                style="border: 0"
                src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDfEmGOSH8nslnLqsm3HWenL9F6ZiJrqxk
    &q=Nadrazni+28+paskov"
                allowfullscreen
              ></iframe>
            </v-flex>
          </v-layout>
          <v-layout justify-center>
            <span class="footer-company-info"
              >Bur & Ann. CZ, s.r.o., se sídlem Nádražní 28, 739 21 Paskov, IČO:
              25852108, DIČ: CZ25852108, zapsaná v obchodním rejstříku vedeném
              Krajským soudem v Ostravě, oddíl C, vložka 21893</span
            >
          </v-layout>
        </v-layout>
      </section>
    </v-content>
  </v-app>
</template>

<script>
export default {
  mounted() {
    this.$http
      .get("https://pivovarpaskov.cz/api/beers")
      // .get("http://localhost:5000/api/beers")
      // .then((response) => (this.beers = response.data));
      .then((response) => {
        this.beers = response.data;

        // get top fermented beers
        this.topFermentedBeers = this.beers.filter((e) => {
          return e.isTopFermented;
        });

        // get bottom fermented beers
        this.bottomFermentedBeers = this.beers.filter((e) => {
          return !e.isTopFermented;
        });
      });
  },
  methods: {
    showTopFermentedDialog: function (index) {
      this.topFermentedIndex = index;
      this.topFermentedDialog = true;
    },
    showBottomFermentedDialog: function (index) {
      this.bottomFermentedIndex = index;
      this.bottomFermentedDialog = true;
    },
    toggleHistory: function () {
      this.toggleHist = !this.toggleHist;
      if (this.toggleHist) {
        this.historyBtnText = "Zavřít";
      } else {
        this.historyBtnText = "Chci vědět víc!";
      }
    },
    handleScroll() {
      if (window.scrollY > 0) {
        this.showSmallLogo = true;
        this.toolbarColor = "primary";
      } else {
        this.showSmallLogo = false;
        this.toolbarColor = "transparent";
      }
    },
  },
  created() {
    this.overlay = true;
    document.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    document.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    easingOptions() {
      return {
        duration: 0,
        offset: 0,
        easing: "linear",
      };
    },
  },
  data: () => ({
    overlay: false,
    hideOnScroll: true,
    rowPageItems: [5, 10, 25, { text: "Vše", value: -1 }],
    historyBtnText: "Chci vědět víc!",
    showSmallLogo: false,
    toggleHist: false,
    logoPath: "images/logo-color-small.png",
    topFermentedIndex: 0,
    bottomFermentedIndex: 0,
    topFermentedDialog: false,
    bottomFermentedDialog: false,
    show: true,
    drawer: false,
    expand: false,
    toolbarColor: "transparent",
    headers: [
      { text: "Název piva", align: "start", value: "" },
      {
        text: "KEG",
        align: "start",
        value: "keg",
        width: 100,
        sortable: false,
      },
      {
        text: "Na čepu",
        align: "start",
        value: "cep",
        width: 100,
        sortable: false,
      },
      {
        text: "PET",
        align: "start",
        value: "lahev",
        width: 100,
        sortable: false,
      },
    ],
    beers: [],
    topFermentedBeers: [],
    bottomFermentedBeers: [],
  }),
};
</script>



<style>
@import url("https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap");

.footer-company-info {
  font-size: 0.8em;
  font-style: italic;
  margin-bottom: -15px;
}

.nowrap {
  white-space: nowrap;
  overflow: hidden;
}

.beer-description {
  font-style: italic;
  font-size: 1em;
  text-align: justify;
  max-width: 70%;
  margin: 0 auto;
}

.justified {
  text-align: justify;
}

.v-data-table-header-mobile {
  display: none !important;
}

.hidden {
  display: none;
}

.beer-column {
  width: 100px;
}
.beer-properties {
  font-size: 0.7em;
}

.bold {
  font-weight: bold;
}

.table-header {
  font-size: 50px;
}

.link {
  text-decoration: none;
  color: white;
}

.link:visited {
  text-decoration: none;
  color: white;
}

.link:active {
  text-decoration: none;
  color: white;
}

.v-application a {
  text-decoration: none;
  color: white;
}

.beer-name {
  font-size: 1.2em !important;
}

.beer-title {
  font-weight: 400;
  font-size: 0.9em;
}

#beer-table > div.v-table__overflow > table > thead th {
  font-size: 1.2em;
}

#map {
  height: 100%;
  width: 100%;
}
.clickable {
  cursor: pointer;
}
table.v-table tbody td {
  font-size: 1.2em;
}
h1 {
  font-size: 2em;
}
p {
  font-size: 1.5em;
}

.fixed {
  position: fixed;
  width: 100%;
  z-index: 10;
}

.white-text {
  color: white;
}

.menu {
  font-size: 1.2em;
}

/* .parallax {
  height: 100vh !important;
} */

.transparent table {
  background-color: transparent !important;
}

.transparent {
  background-color: transparent !important;
}

.v-datatable__actions {
  background-color: transparent !important;
}

.none {
  display: none;
}

.theme--light.v-table {
  background-color: transparent !important;
}
.theme--light.v-table tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
  background-color: rgba(255, 255, 255, 0.1);
}

.centered {
  text-align: center;
  display: inherit;
}

.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

section.module.parallax {
  background-repeat: no-repeat;
  /* For mobile version and IE disable this!*/
  background-attachment: fixed;
  background-size: cover;
  height: 100vh;
}

@media (min-width: 481px) and (max-width: 767px) {
  section.module.parallax {
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-size: cover;
    height: 100vh;
  }
  .beer-description {
    font-style: italic;
    font-size: 1em;
    text-align: justify;
    max-width: 100%;
    margin: 0 auto;
  }

  .footer-company-info {
    font-size: 0.8em;
    font-style: italic;
    margin-bottom: 10px;
  }
}

/* 
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
  section.module.parallax {
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-size: cover;
    height: 100vh;
  }

  .beer-description {
    font-style: italic;
    font-size: 1em;
    text-align: justify;
    max-width: 100%;
    margin: 0 auto;
  }

  .footer-company-info {
    font-size: 0.8em;
    font-style: italic;
    margin-bottom: 10px;
  }
}

.container {
  /* max-width: 1300px; */
  height: 100%;
  margin: 0 auto;
  font-size: 1.4em;
}

#main-parallax {
  background-image: url("~/images/main-bg-dark-crop2.png");
}

#nabidka-piv-parallax {
  background-image: url("~/images/main1.jpg");
}

#historie-parallax {
  background-image: url("~/images/bg5.jpg");
}

#kontakt-parallax {
  background-image: url("~/images/tanky-test.png");
}

#logo {
  /* logo scaling against window size */
  max-width: 100%;
  height: auto;
  width: auto;
  /* centering logo */
  position: relative;
  top: 50%;
  left: 50%;
}

.logo-container img {
  /* centering logo */
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

/* TRANSITION */
/* always present */
.expand-transition {
  transition: all 0.5s ease;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter,
.expand-leave {
  height: 0;
  opacity: 0;
}
.theme--dark.v-data-table {
  background-color: #382e2c;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue